var EquipmentLegacyModule = /** @class */ (function () {
    function EquipmentLegacyModule() {
    }
    return EquipmentLegacyModule;
}());
export { EquipmentLegacyModule };
